import {
  Cell,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from "recharts";
import ChartCard from "./ChartCard";
import { CHART_COLORS, getChartTheme } from "../utils/chartTheme";

const RADIAN = Math.PI / 180;

function PercentLabel({ cx, cy, midAngle, innerRadius, outerRadius, percent }) {
  if (!percent || percent < 0.04) return null;
  const radius = innerRadius + (outerRadius - innerRadius) * 0.55;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  return (
    <text
      x={x}
      y={y}
      fill="#fff"
      textAnchor="middle"
      dominantBaseline="central"
      fontSize={12}
      fontWeight={700}
      fontFamily='"Open Sans", sans-serif'
    >
      {`${Math.round(percent * 100)}%`}
    </text>
  );
}

export default function HoursMixChart({ data = [], isDarkMode = false }) {
  const theme = getChartTheme(isDarkMode);
  const hasData = data.some((d) => d.value > 0);
  return (
    <ChartCard
      title="Përzierja e orëve"
      empty={!hasData}
      accent={CHART_COLORS.yellow}
    >
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="46%"
            innerRadius={58}
            outerRadius={96}
            paddingAngle={2}
            labelLine={false}
            label={PercentLabel}
            stroke={theme.pieStroke}
            strokeWidth={2}
          >
            {data.map((entry) => (
              <Cell
                key={entry.name}
                fill={entry.fill}
                // Inline style beats global `.dark .recharts-wrapper * { fill: white }`
                style={{ fill: entry.fill }}
              />
            ))}
          </Pie>
          <Tooltip
            contentStyle={theme.tooltipContentStyle}
            labelStyle={theme.tooltipLabelStyle}
            itemStyle={theme.tooltipItemStyle}
            formatter={(val) => [`${val} h`, "Ore"]}
          />
          <Legend {...theme.legendProps} verticalAlign="bottom" height={36} />
        </PieChart>
      </ResponsiveContainer>
    </ChartCard>
  );
}
